import { DuckbillDirectoryBanner } from '@frontend/assets';
import { Anchor, ImageBackground, Text, YStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';
import { Env } from '@frontend/web/utils';

export const DirectoryCard = () => {
  const { track } = useAnalytics();

  return (
    <YStack className="gap-sm">
      <Text color="tertiary" type="p-sm" uppercase>
        BROWSE TASKS
      </Text>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <Anchor
        href={Env.VITE_DUCKBILL_DIRECTORY_URL}
        onClick={() => track({ event: 'directoryBannerSelected', topic: 'examples' })}
      >
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <ImageBackground className="p-md h-[160px] rounded-lg" source={DuckbillDirectoryBanner}>
          <Text className="font-bold text-pink-50" type="h2">
            DUCKBILL DIRECTORY
          </Text>
          <Text className="text-pink-50" type="p-sm">
            We created a searchable directory of all our most common tasks.
          </Text>
        </ImageBackground>
      </Anchor>
    </YStack>
  );
};
